import { render, staticRenderFns } from "./customerType.vue?vue&type=template&id=e6cd9e14&"
import script from "./customerType.vue?vue&type=script&lang=js&"
export * from "./customerType.vue?vue&type=script&lang=js&"
import style0 from "./customerType.vue?vue&type=style&index=0&id=e6cd9e14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports